import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import React, { useCallback, useState } from 'react'

import { HHAlert } from 'components/common/HHAlert'
import T from 'T'

const PciNoteWarning = () => {
  const [isExpanded, setIsExpanded] = useState(false)

  const handleToggleExpanded = useCallback(() => setIsExpanded(prev => !prev), [])

  return (
    <HHAlert
      action={
        <Button color="warning" size="small" variant="outlined" onClick={handleToggleExpanded}>
          {isExpanded ? T.LESS_INFO : T.MORE_INFO}
        </Button>
      }
      icon={<WarningAmberIcon />}
      severity="warning"
      sx={{ mt: 1.5, borderColor: 'warning.main', borderStyle: 'solid', borderWidth: '1.5px' }}
    >
      <Box component="span" sx={{ display: 'block', fontWeight: 700 }}>
        {T.PCI_NOTE_WARNING_TITLE}
      </Box>
      {isExpanded && T.PCI_NOTE_WARNING_BODY}
    </HHAlert>
  )
}

export default PciNoteWarning
